// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__AP8+A"};